import { useState } from 'react'
import { useSessione } from '../../servizi/sessione.tsx'
import { Avviso } from '../../componenti/Pezzi.tsx'
import { Bottone } from '../../componenti/base.tsx'

/**
 * «Riferimento per il messenger» (479). Nel messenger non si scrivono dati dei beneficiari (regola del
 * committente del 28/10/2026): per parlare di una persona si incolla il riferimento alla scheda, cioe'
 * il numero e il collegamento, senza nome ne' altro. Chi apre il collegamento vede la scheda solo se
 * il suo incarico la copre: il controllo resta del gestionale.
 *
 * Restituisce il comando, per l'intestazione della scheda, e l'avviso che conferma la copia.
 */
export function useRiferimentoMessenger(id: string, numeroScheda: number | null) {
  const { io, puo } = useSessione()
  // L'esito ricorda la scheda a cui si riferisce: passando a un'altra scheda l'avviso non resta.
  const [esito, setEsito] = useState<{ id: string; copiato: boolean; testo: string } | null>(null)

  // Prima che la scheda sia caricata il numero non c'e': niente comando.
  if (!puo('chat.usa') || numeroScheda === null) return { comando: null, avviso: null }

  const gestionale = io?.indirizzi?.gestionale ?? window.location.origin
  const testo = `Scheda n. ${numeroScheda}: ${gestionale}/persone/${id}`

  async function copia() {
    try {
      await navigator.clipboard.writeText(testo)
      setEsito({ id, copiato: true, testo })
    } catch {
      setEsito({ id, copiato: false, testo })
    }
  }

  const comando = <Bottone variante="secondario" onClick={() => void copia()}>Riferimento per il messenger</Bottone>
  const avviso = esito?.id !== id ? null : esito.copiato
    ? (
      <Avviso tipo="successo">
        Riferimento copiato: incollalo nel messenger. Chi lo apre vede la scheda solo se il suo incarico
        la copre.
      </Avviso>
    )
    : (
      <Avviso tipo="attenzione">
        Il browser non permette di copiare: copia a mano questo riferimento.{' '}
        <span className="mono messenger-indirizzo">{esito.testo}</span>
      </Avviso>
    )
  return { comando, avviso }
}
